import React from "react";
import { Link } from "react-router-dom";
import Page from "../../../common/layout/Page";
import Loader from "../../../common/Loader";
import useEpSessionV2 from "./hooks/useEpSessionV2";
import EpStartV2 from "./components/EpStartV2";
import EpCallingV2 from "./components/EpCallingV2";
import EpSessionMainV2 from "./components/EpSessionMainV2";

const EpSessionV2Page = (props) => {
  const epId = props.match.params.id;
  const sessionData = useEpSessionV2(epId);
  const { ep, isLoading, errors } = sessionData;

  if (isLoading) {
    return (
      <Page bgTransparent container="container-fluid" title="">
        <div className="text-center p-5">
          <Loader />
          <p className="mt-3 text-muted">Chargement de la session EP...</p>
        </div>
      </Page>
    );
  }

  if (Object.keys(errors).length > 0 || !ep) {
    return (
      <Page bgTransparent container="container-fluid" title="">
        <div className="container" style={{ maxWidth: "95%" }}>
          <Link to="/ep" className="btn btn-link">
            <i className="fa fa-arrow-left mr-2" />
            Revenir au calendrier des EP
          </Link>
        </div>
        <div className="alert alert-danger m-4">
          <i className="fa fa-exclamation-triangle mr-2" />
          <strong>Erreur lors du chargement de l'EP</strong>
          <p className="mb-0 mt-2">{Object.values(errors).join(", ")}</p>
        </div>
      </Page>
    );
  }

  const renderContent = () => {
    if (!ep.startedAt) {
      return <EpStartV2 sessionData={sessionData} />;
    }
    if (!ep.calledAt) {
      return <EpCallingV2 sessionData={sessionData} />;
    }
    return <EpSessionMainV2 sessionData={sessionData} />;
  };

  return (
    <Page bgTransparent container="container-fluid" title="" noPadding noMargin>
      <div className="container-fluid" style={{ maxWidth: "95%" }}>
        <Link to="/ep" className="btn btn-link mb-2">
          <i className="fa fa-arrow-left mr-2" />
          Revenir au calendrier des EP
        </Link>
        {renderContent()}
      </div>
    </Page>
  );
};

export default EpSessionV2Page;
